import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import UserActionCreator from '../../../../actions/UserActionCreator';
import useUserAndToken from '../../../../core/useUserAndToken';
import PwaInstallBonusDialog from './PwaInstallBonusDialog';
import { usePwaInstallTracking } from '../hooks/usePwaInstallTracking';

/**
 * Mount inside the authenticated app shell.
 * Reports PWA install once and shows the bonus dialog when coins are credited.
 */
export function PwaInstallTracking() {
    const { user, token } = useUserAndToken();
    const dispatch = useDispatch();
    const { lastResult, bonusDialogOpen, closeBonusDialog } = usePwaInstallTracking({ user, token });

    useEffect(() => {
        if (lastResult?.status === 'credited') {
            dispatch(UserActionCreator.refreshUser());
        }
    }, [dispatch, lastResult]);

    return (
        <PwaInstallBonusDialog
            open={bonusDialogOpen}
            bonusCoins={lastResult?.bonusCoins ?? 0}
            onClose={closeBonusDialog}
        />
    );
}

export default PwaInstallTracking;
